import {
    LOAD_RENTAL_PRICE,
    CREATE_RENTAL_PRICE,
    UPDATE_RENTAL_PRICE,
    LOAD_RENTAL_PRICE_DETAIL,
    EXPORT_RENTAL_PRICE,
    REMOVE_LISTS
} from './actions'

const initialState = {
    lists: [],
    listDetail: null,
    total: 1,
    loading: false,
    draw: -1,
    check: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REMOVE_LISTS:
            return initialState

        case LOAD_RENTAL_PRICE.REQUEST:
            const { loading } = action.payload.data
            return {
                ...state,
                loading: loading,
            }

        case LOAD_RENTAL_PRICE.SUCCESS:
            const { page, pageSize } = action.payload
            return {
                ...state,
                lists: action.payload.lists.data,
                total:
                    action.payload.lists.total - 1 <= 0
                      ? 1
                      : action.payload.lists.total <= 0
                      ? 1
                      : action.payload.lists.total,
                loading: false,
                draw: Math.floor(Math.random() * 999 + 1),
            }

        case CREATE_RENTAL_PRICE.REQUEST:
            return {
                ...state,
                loading: true,
            }

        case CREATE_RENTAL_PRICE.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case UPDATE_RENTAL_PRICE.REQUEST:
            return {
                ...state,
                loading: true,
            }

        case UPDATE_RENTAL_PRICE.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case LOAD_RENTAL_PRICE_DETAIL.REQUEST:
            return {
                ...state,
                loading: true,
            }

        case LOAD_RENTAL_PRICE_DETAIL.SUCCESS:
            return {
                ...state,
                listDetail: action.payload.listDetail.data,
                loading: false,
                check: false,
            }

        case EXPORT_RENTAL_PRICE.REQUEST:
            return {
                ...state,
                loading: true,
            }

        case EXPORT_RENTAL_PRICE.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        default:
            return state
    }
}